/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useRef, useState} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../_metronic/helpers'
import LeadServiceAPI from '../../../api/LeadServiceAPI'
import {toast} from 'react-toastify'
import moment from 'moment'
import Swal from 'sweetalert2'
import {Link} from 'react-router-dom'
import authAPI from '../../../api/authAPI'
import ReactPaginate from 'react-paginate'
import './contact.css'
import ReactDatePicker from 'react-datepicker'
// import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

function CustomerListIndividual() {
  const [customerList, setCustomerList] = useState<any>([])
  const [showLeadPopup, setLeadPoppup] = useState<boolean>(false)
  const [uploadStatus, setUploadStatus] = useState<boolean>(false)
  const [contactStatus, setContactStatus] = useState<boolean>(false)
  const [contactStatusCompany, setContactStatusCompany] = useState<boolean>(false)
  const [stateLead, setStateLead] = useState<number>(1)

  const [currentState, setCurrentState] = useState<'individual' | 'company'>('individual')
  const [fullName, setFullName] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [birthday, setBirthday] = useState<any>('')
  const [leadOwner, setLeadOwner] = useState('')
  const [leadOwnerName, setLeadOwnerName] = useState('')
  const [email, setEmail] = useState('')
  const [companyName, setCompanyName] = useState('')
  const [anniversary, setAnniversary] = useState<any>('')
  const [leadStatus, setLeadStatus] = useState('')
  const [birthdayDay, setBirthdayDay] = useState(0)
  const [birthdayMonth, setBirthdayMonth] = useState(0)
  const [anniversaryDay, setAnniversaryDay] = useState(0)
  const [anniversaryMonth, setAnniversaryMonth] = useState(0)
  const [errors, setErrors] = useState<any>({})
  const [leadStatusList, setLeadStatusList] = useState<any>([])
  const [leadOwnerList, setLeadOwnerList] = useState<any>([])
  const [imgPath, setImgPath] = useState<any>('')
  const [companyName2, setCompanyName2] = useState('')
  const [phoneNumberCompany, setPhoneNumberCompany] = useState('')
  const [leadOwnerCompany, setLeadOwnerCompany] = useState('')
  const [emailCompany, setEmailCompany] = useState('')
  const [officialAddressCompany, setOfficialAddressCompany] = useState('')
  const [leadStatusCompany, setLeadStatusCompany] = useState('')
  const [updatingID, setUpdatingID] = useState('')
  const [isEdit, setIsEdit] = useState<boolean>(false)
  const initialOffset = 0
  const initialLimit = 10
  const itemsPerPage = 10
  const [avatarImgPath, setAvatarImgPath] = useState<string>('')

  const [offset, setOffset] = useState(initialOffset)
  const [limit, setLimit] = useState(initialLimit)
  const [totalPages, setTotalPages] = useState(0)
  const [totalCustomers, setTotalCustomers] = useState(0)
  const currentPage = Math.floor(offset / limit)
  const handleDateChange = (date: any) => {
    setBirthday(date)
    const dateObject = date
    const day = dateObject.getDate() // Get the day (1-31)
    const month = dateObject.getMonth() + 1 // Get the month (0-11). Adding 1 because months are zero-based.
    const year = dateObject.getFullYear() // Get the four-digit year

    setBirthdayDay(day)
    setBirthdayMonth(month)
  }
  const handleImageAvatarError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    e.currentTarget.src = toAbsoluteUrl('/media/avatars/blank.png')
  }
  const handlePageChange = (selected: any) => {
    const newOffset = selected === 0 ? 0 : selected * limit
    let data = {
      // lead_owner_id: 8,
      limit: limit,
      offset: newOffset,
    }
    LeadServiceAPI.getCustomerListIndividual(data).then(
      (res: any) => {
        if (res?.data?.success) {
          setCustomerList(res?.data?.data)
          setTotalPages(Math.ceil(res?.data?.totalCount / limit))
          setTotalCustomers(res?.data?.totalCount || 0)
          setOffset(newOffset)
        } else {
          setCustomerList([])
        }
      },
      (err: any) => {
        toast.error(err?.response?.data?.message, {theme: 'dark'})
      }
    )
  }

  useEffect(() => {
    authAPI.getMyProfile().then((res: any) => {
      setLeadOwner(res?.data?.data?.user_id)
      setLeadOwnerName(res?.data?.data?.name)
    })
  }, [])
  // get customers
  const getCustomerListIndividual = (newOffset: number = 0) => {
    let data: any;
    if(newOffset) {
      setOffset(newOffset)
      data = {
        limit: limit,
        offset: newOffset,
      }
    }
    else {
      data = {
        limit: limit,
        offset: offset,
      }
    }
    LeadServiceAPI.getCustomerListIndividual(data).then(
      (res: any) => {
        if (res?.data?.success) {
          setCustomerList(res?.data?.data)
          res?.data?.data.length===0? setTotalPages(Math.ceil(res?.data?.totalCount / limit)+1) : setTotalPages(Math.ceil(res?.data?.totalCount / limit))
          setTotalCustomers(res?.data?.totalCount || 0)
          setImgPath(res?.data?.leadImageFolderPath)
          setAvatarImgPath(res?.data?.leadImageFolderPath)
        } else {
          setCustomerList([])
        }
      },
      (err: any) => {
        toast.error(err?.response?.data?.message, {theme: 'dark'})
      }
    )
  }

  // init
  useEffect(() => {
    getCustomerListIndividual()
  }, [])

  const handleFullNameChange = (e: any) => {
    setFullName(e.target.value)
  }

  const handlePhoneNumberChange = (e: any) => {
    setPhoneNumber(e.target.value)
  }

  const handleLeadOwnerChange = (e: any) => {
    setLeadOwner(e.target.value)
  }

  const handleEmailChange = (e: any) => {
    setEmail(e.target.value)
  }

  const handleCompanyNameChange = (e: any) => {
    setCompanyName(e.target.value)
  }

  const handleAnniversaryChange = (e: any) => {
    setAnniversary(e)
    const dateObject = new Date(e)
    const day = dateObject.getDate() // Get the day (1-31)
    const month = dateObject.getMonth() + 1 // Get the month (0-11). Adding 1 because months are zero-based.
    const year = dateObject.getFullYear() // Get the four-digit year

    setAnniversaryDay(day)
    setAnniversaryMonth(month)
  }

  const handleLeadStatusChange = (e: any) => {
    setLeadStatus(e.target.value)
  }
  const ClearOthers = () => {
    // Reset the form after submission
    setFullName('')
    setPhoneNumber('')
    setBirthday('')
    setBirthdayDay(0)
    setBirthdayMonth(0)
    setLeadOwner('')
    setEmail('')
    setCompanyName('')
    setAnniversary('')
    setAnniversaryDay(0)
    setAnniversaryMonth(0)
    setLeadStatus('')
    setErrors({})
    setSelectedImage(null)

    setCompanyName2('')
    setPhoneNumberCompany('')
    setLeadOwnerCompany('')
    setEmailCompany('')
    setOfficialAddressCompany('')
    setLeadStatusCompany('')
    setUpdatingID('')
    setSelectedImageCompany(null)
    
    setIsEdit(false)
  }
  const clearFields = () => {
    ClearOthers()
    setLeadPoppup(false)
  }
  // Handle Submit Lead Form
  const handleFormSubmit = (e: any) => {
    e?.preventDefault()
    // Perform API integration here
    // Use the form data and make an API request to create a lead
    let formData = new FormData()
    if (isEdit) {
      formData.append('id', updatingID?.toString())
    }
    formData.append('lead_type', currentState === 'individual' ? '1' : '2')
    formData.append('lead_owner_id', leadOwner)
    formData.append('lead_status_id', leadStatus)
    formData.append('name', fullName)
    formData.append('email', email)
    formData.append('phone', phoneNumber)
    formData.append('company_name', companyName)
    formData.append('birthday', birthday)
    if (anniversaryDay > 0) {
      formData.append('anniversary_day', anniversaryDay?.toString())
      formData.append('anniversary_month', anniversaryMonth?.toString())
    }
    if (birthdayMonth > 0) {
      formData.append('birthday_month', birthdayMonth?.toString())
      formData.append('birthday_day', birthdayDay?.toString())
    }
    if (selectedImage) {
      formData.append('image', selectedImage)
    }
    if (isEdit) {
      // API Call
      LeadServiceAPI.editLead(formData).then(
        (res: any) => {
          if (res?.data?.success) {
            clearFields()
            toast.success(res?.data?.message, {theme: 'dark'})
            setCurrentState('individual')
            setLeadPoppup(false)
            getCustomerListIndividual()
          } else {
            toast.error(res?.data?.message, {theme: 'dark'})
          }
        },
        (err: any) => {
          if (err.response && err.response.status === 400) {
            toast.error(err.response.data.message || 'API request error: Bad Request')
          } else {
            toast.error(err?.response?.data?.message || 'Failed response', {theme: 'dark'})
          }
        }
      )
    } else {
      // API Call
      LeadServiceAPI.createLead(formData).then(
        (res: any) => {
          if (res?.data?.success) {
            clearFields()
            toast.success(res?.data?.message, {theme: 'dark'})
            setCurrentState('individual')
            setLeadPoppup(false)
            getCustomerListIndividual()
          } else {
            toast.error(res?.data?.message, {theme: 'dark'})
          }
        },
        (err: any) => {
          if (err.response && err.response.status === 400) {
            toast.error(err.response.data.message || 'API request error: Bad Request')
          } else {
            toast.error(err?.response?.data?.message || 'Failed response', {theme: 'dark'})
          }
        }
      )
    }
  }

  const [selectedImage, setSelectedImage] = useState<File | null | any>(null)
  const [selectedImageCompany, setSelectedImageCompany] = useState<File | null | any>(null)

  const handleImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      setSelectedImage(event.target.files[0])
    }
  }
  const handleImageUploadCompany = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      setSelectedImageCompany(event.target.files[0])
    }
  }
  const fileInputRef = useRef<HTMLInputElement | null>(null)
  const fileInputRefCompany = useRef<HTMLInputElement | null>(null)
  const handleClearImage = () => {
    setSelectedImage(null)
  }
  const handleClearImageCompany = () => {
    setSelectedImageCompany(null)
  }
  // handle popup
  const handlePopup = () => {
    setLeadPoppup(!showLeadPopup)
    setUploadStatus(false)
    setContactStatus(false)
    ClearOthers()
    setCurrentState('individual')
  }

  // handle upload
  const handleUploadBtnAction = () => {
    setUploadStatus(true)
  }

  const handleCreateContact = (param: string) => {
    if (param === 'individual') {
      setUploadStatus(false)
      setContactStatusCompany(false)

      setContactStatus(true)
    } else {
      setUploadStatus(false)
      setContactStatus(false)

      setContactStatusCompany(true)
    }
  }

  // init
  useEffect(() => {
    if (stateLead === 1) {
      setStateLead(stateLead)
      handleCreateContact('individual')
    } else if (stateLead === 2) {
      setStateLead(stateLead)
      handleCreateContact('company')
    } else {
      setStateLead(stateLead)
      console.log('first')
    }
  }, [stateLead])

  useEffect(() => {
    getLeads()
    getLeadOwners()
  }, [])

  // lead status
  const getLeads = () => {
    LeadServiceAPI.getLeadStatus().then(
      (res: any) => {
        if (res?.data?.success) {
          setLeadStatusList(res?.data?.data)
        } else {
          setLeadStatusList([])
        }
      },
      (err: any) => {
        setLeadStatusList([])
      }
    )
  }

  // lead owner list
  const getLeadOwners = () => {
    LeadServiceAPI.getLeadOwnerList().then(
      (res: any) => {
        if (res?.data?.success) {
          setLeadOwnerList(res?.data?.data)
        } else {
          setLeadOwnerList([])
        }
      },
      (err: any) => {
        setLeadOwnerList([])
      }
    )
  }

  // handleCompanyFormSubmit
  const handleCompanyFormSubmit = () => {
    // if (validateForm()) {
    // Perform form submission or API call here
    let formData = new FormData()
    if (isEdit) {
      formData.append('id', updatingID?.toString())
    }
    formData.append('lead_type', currentState === 'individual' ? '1' : '2')
    formData.append('lead_owner_id', leadOwnerCompany)
    formData.append('lead_status_id', '2')
    formData.append('email', emailCompany)
    formData.append('official_address', officialAddressCompany)
    formData.append('phone', phoneNumberCompany)
    formData.append('company_name', companyName2)

    if (selectedImageCompany) {
      formData.append('image', selectedImageCompany)
    }
    // API Call
    if (isEdit) {
      LeadServiceAPI.editLead(formData).then(
        (res: any) => {
          if (res?.data?.success) {
            clearFields()
            toast.success(res?.data?.message, {theme: 'dark'})
            setCurrentState('individual')
            setLeadPoppup(false)
            getCustomerListIndividual()
          } else {
            toast.error(res?.data?.message, {theme: 'dark'})
          }
        },
        (err: any) => {
          if (err.response && err.response.status === 400) {
            toast.error(err.response.data.message || 'API request error: Bad Request')
          } else {
            toast.error(err?.response?.data?.message || 'Failed response', {theme: 'dark'})
          }
        }
      )
    } else {
      LeadServiceAPI.createLead(formData).then(
        (res: any) => {
          if (res?.data?.success) {
            clearFields()
            toast.success(res?.data?.message, {theme: 'dark'})
            setCurrentState('individual')
            setLeadPoppup(false)
            getCustomerListIndividual()
          } else {
            toast.error(res?.data?.message, {theme: 'dark'})
          }
        },
        (err: any) => {
          if (err.response && err.response.status === 400) {
            toast.error(err.response.data.message || 'API request error: Bad Request')
          } else {
            toast.error(err?.response?.data?.message || 'Failed response', {theme: 'dark'})
          }
        }
      )
    }
  }

  // handle edit
  const handleEdit = (data: any) => {
    // console.log(imgPath + '/' + data?.image)

    setIsEdit(true)
    setUpdatingID(data?.id)
    
    setContactStatus(true)
    setUploadStatus(false)
    setCurrentState(data?.lead_type === 1 ? 'individual' : 'company')
    setLeadPoppup(true)

    // setting data for individual
    setLeadStatus(data?.lead_status_id)
    setPhoneNumber(data?.phone)
    setLeadOwner(data?.lead_owner_id)
    setCompanyName(data?.company_name)
    setEmail(data?.email)
    setSelectedImage(imgPath + '/' + data?.image)
    
    // setting data for company
    setLeadStatusCompany(data?.lead_status_id)
    setPhoneNumberCompany(data?.phone)
    setLeadOwnerCompany(data?.lead_owner_id)
    setCompanyName2(data?.company_name)
    setEmailCompany(data?.email)
    setSelectedImageCompany(imgPath + '/' + data?.image)
    
    // set
    if (data?.lead_type === 1) {     
      setFullName(data?.name)      
      setAnniversary(
        data?.anniversary_month
          ? new Date('2023-' + data?.anniversary_month + '-' + data?.anniversary_day)
          : ''
      )
      setAnniversaryDay(data?.anniversary_day)
      setAnniversaryMonth(data?.anniversary_month)
      setBirthdayDay(data?.birthday_day)
      setBirthdayMonth(data?.birthday_month)
      setBirthday(
        data?.birthday_month
          ? new Date('2023-' + data?.birthday_month + '-' + data?.birthday_day)
          : ''
      )
    } else {
      setOfficialAddressCompany(data?.official_address)
    }
  }

  // remove
  const handleRemove = (id: number) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to remove this item?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, remove it!',
    }).then((result: any) => {
      if (result.isConfirmed) {
        LeadServiceAPI.deleteLead(id).then(
          (res: any) => {
            if (res?.data?.success) {
              toast.success(res?.data?.message, {theme: 'dark'})
              // Perform the removal logic
              clearFields();
              (customerList.length === 1 && offset !== 0) ? getCustomerListIndividual(offset - limit) : getCustomerListIndividual();
            } else {
              toast.error(res?.data?.message, {theme: 'dark'})
            }
          },
          (err: any) => {
            toast.error(err?.response?.data?.message, {theme: 'dark'})
          }
        )
      }
    })
  }
  const handleFileUpload = (event: any) => {
    const file = event.target.files[0]
    if (event.target.files[0]) {
      let formData = new FormData()
      formData.append('lead_file', file)
      LeadServiceAPI.downloadLead(formData).then(
        (res: any) => {
          if (res?.data?.success) {
            toast.success(res?.data?.message, {theme: 'dark'})
            clearFields()
          } else {
            toast.error(res?.data?.message, {theme: 'dark'})
          }
        },
        (err: any) => {
          toast.error(err?.response?.data?.message, {theme: 'dark'})
        }
      )
    }
  }
  // handle on image error
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    e.currentTarget.src = toAbsoluteUrl('/media/icons/fupload.png')
  }
  // render
  return (
    <div className={`card`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>All Customers</span>
          <span className='text-muted mt-1 fw-semibold fs-7'>
            Over {totalCustomers} customers
          </span>
        </h3>
        <div
          className='card-toolbar'
          data-bs-toggle='tooltip'
          data-bs-placement='top'
          data-bs-trigger='hover'
          title='Click to add a user'
        >
          <button
            type='button'
            onClick={handlePopup}
            className='btn btn-sm btn-primary'
            style={{borderRadius: 80}}
          >
            <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
            New Lead
          </button>
        </div>
      </div>
      {/* end::Header */}

      {/* Modal */}

      {showLeadPopup && (
        <div
          className='modal fade show'
          tabIndex={-1}
          role='dialog'
          style={{
            display: showLeadPopup ? 'flex' : 'none',
            alignItems: 'center',
            backdropFilter: 'contrast(0.4)',
            overflow: 'hidden',
          }}
        >
          <div className='modal-dialog  modal-lg' role='document'>
            <div className='modal-content'>
              <div className='modal-header'>
                <div className='flex-grow-1'>
                <h5 className='modal-title'>{!isEdit ? 'Add New Lead': 'Edit Lead'}</h5>
                </div>
                <div className='flex-grow-0 d-flex'>
                  {uploadStatus === false && contactStatus === true && (
                    <div className='nav-group nav-group-outline mx-auto' data-kt-buttons='true'>
                      <a
                        href='#'
                        className={
                          'btn btn-color-gray-400 btn-active btn-active-secondary px-6 py-3 me-2 ' +
                          (currentState === 'individual' && 'active')
                        }
                        onClick={() => {
                          isEdit ? console.log('clicked') : setCurrentState('individual')
                        }}
                        data-kt-plan='individual'
                      >
                        Individual
                      </a>
                      <a
                        href='#'
                        className={
                          'btn btn-color-gray-400 btn-active btn-active-secondary px-6 py-3 me-2 ' +
                          (currentState === 'company' && 'active')
                        }
                        onClick={() => {
                          isEdit ? console.log('clicked') : setCurrentState('company')
                        }}
                        data-kt-plan='company'
                      >
                        Company
                      </a>
                    </div>
                  )}
                  <button
                    type='button'
                    className='btn btn-sm close'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={handlePopup}
                  >
                    <i className='fa fa-close' style={{fontSize: '2rem'}}></i>
                  </button>
                </div>
              </div>
              <div
                className={`${
                  contactStatus === false && 'py-12'
                } modal-body d-flex justify-content-center`}
              >
                <div className='col-lg-10 d-flex flex-column'>
                  {/* default body */}
                  {uploadStatus === false && contactStatus === false && (
                    <div className='row align-items-center'>
                      <div
                        className='col-lg-6  d-flex flex-wrap justify-content-center'
                        style={{border: '1px dashed #989898', padding: '50px 34px'}}
                      >
                        <img src={toAbsoluteUrl('/media/icons/folder.png')} alt='upload' />
                        <p style={{textAlign: 'center'}}>
                          CSV files can be uploaded to Asterics CRM.{' '}
                          <span style={{color: 'green'}}>Get your document ready</span>
                        </p>
                        <button
                          type='button'
                          className='btn btn-dark'
                          style={{padding: '5px 30px'}}
                          onClick={handleUploadBtnAction}
                        >
                          Upload
                        </button>
                      </div>
                      <div className='col-lg-1  d-flex flex-wrap justify-content-center'>Or</div>

                      <div
                        className='col-lg-5  d-flex flex-wrap justify-content-center'
                        style={{border: '1px dashed #989898', padding: '35px 20px'}}
                      >
                        <img src={toAbsoluteUrl('/media/icons/profile.png')} alt='upload' />
                        <p style={{textAlign: 'center'}}>
                          You can manually type the contact details you’ll like to add to the CRM.
                        </p>
                        <button
                          type='button'
                          className='btn btn-dark'
                          style={{padding: '5px 30px'}}
                          onClick={() => handleCreateContact('individual')}
                        >
                          Add Contact
                        </button>
                      </div>
                    </div>
                  )}

                  {/* if upload status true */}
                  {uploadStatus === true && contactStatus === false && (
                    <div className='row align-items-center'>
                      <div
                        className='col-lg-12 d-flex flex-wrap justify-content-center'
                        style={{border: '1px dotted #989898', padding: '50px 0', borderRadius: 15}}
                      >
                        <img src={toAbsoluteUrl('/media/icons/csv.png')} alt='upload' />
                        <p style={{textAlign: 'center'}} className='w-100 mt-2'>
                          <span style={{color: '#1280E0', fontSize: 18}}>
                            {' '}
                            Select a CSV file to upload
                          </span>{' '}
                          <br />
                          or drag and drop it here
                        </p>
                        <input
                          type='file'
                          accept='.xlsx'
                          onChange={handleFileUpload}
                          style={{display: 'none'}}
                          id='file-upload-input'
                        />
                        <label
                          htmlFor='file-upload-input'
                          className='btn btn-light text-dark'
                          style={{
                            padding: '5px 50px',
                            color: '#000',
                            fontWeight: 500,
                            fontSize: 15,
                          }}
                        >
                          Upload
                        </label>
                      </div>
                    </div>
                  )}

                  {/* if contact status => true */}
                  {contactStatus === true &&
                    (currentState === 'individual' ? (
                      <form onSubmit={handleFormSubmit}>
                        <div className='row align-items-center mb-5'>
                          <div className='col-lg-12 d-flex flex-wrap justify-content-center mb-5'>
                            <div className='form-group d-flex flex-wrap justify-content-center'>
                              <label className='w-100 text-center'>Profile Photo</label>
                              <div className='d-flex flex-wrap'>
                                <input
                                  type='file'
                                  accept='image/*'
                                  style={{display: 'none'}}
                                  onChange={handleImageUpload}
                                  ref={fileInputRef}
                                />
                                {selectedImage === null ? (
                                  <button
                                    className='bg-light px-5 py-4'
                                    style={{border: 'none', borderRadius: '50%'}}
                                    onClick={(e) => {
                                      e.preventDefault()
                                      if (fileInputRef.current) {
                                        fileInputRef.current.click()
                                      }
                                    }}
                                  >
                                    <i className='fa fa-plus'></i>
                                  </button>
                                ) : (
                                  <div className='selected-image-container w-100'>
                                    <img
                                      className='selected-image'
                                      src={
                                        selectedImage
                                          ? selectedImage instanceof File
                                            ? URL.createObjectURL(selectedImage)
                                            : selectedImage
                                          : ''
                                      }
                                      alt='Selected'
                                      height={40}
                                      onError={handleImageError}
                                    />
                                    <br />
                                    <button
                                      className='remove-image-button m-3'
                                      style={{
                                        background: '#f3f3f3',
                                        borderRadius: 10,
                                        color: 'red',
                                      }}
                                      onClick={handleClearImage}
                                    >
                                      x
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                            {/* Display the selected image */}
                          </div>
                          <div className='col-lg-6'>
                            <div className='form-group mb-3'>
                              <label>Full Name</label>
                              <input
                                required
                                type='text'
                                className='form-control'
                                placeholder='Enter contacts full name'
                                value={fullName}
                                onChange={handleFullNameChange}
                              />
                              {errors.fullName && <p className='text-danger'>{errors.fullName}</p>}
                            </div>
                            <div className='form-group mb-3'>
                              <label>Phone Number</label>
                              <input
                                required
                                type='text'
                                className='form-control'
                                placeholder='Enter contacts Phone '
                                value={phoneNumber}
                                onChange={handlePhoneNumberChange}
                              />
                              {errors.phoneNumber && (
                                <p className='text-danger'>{errors.phoneNumber}</p>
                              )}
                            </div>
                            <div className='form-group mb-3'>
                              <label>Birthday(optional)</label>
                              <ReactDatePicker
                                className='form-control'
                                selected={birthday}
                                onChange={handleDateChange}
                                dateFormat='dd/MM'
                                placeholderText='Select Birth Day'
                                showYearDropdown={false}
                                scrollableYearDropdown
                              />
                            </div>
                            <div className='form-group mb-3'>
                              <label>Lead Owner</label>
                              <input
                                disabled
                                value={leadOwnerName}
                                type='text'
                                className='form-control'
                                placeholder='Select Birth Day'
                              />
                            </div>
                          </div>

                          <div className='col-lg-6'>
                            <div className='form-group mb-3'>
                              <label>Email</label>
                              <input
                                required
                                type='email'
                                className='form-control'
                                placeholder='Enter contacts email'
                                value={email}
                                onChange={handleEmailChange}
                              />
                              {errors.email && <p className='text-danger'>{errors.email}</p>}
                            </div>
                            <div className='form-group mb-3'>
                              <label>Company Name (optional)</label>
                              <input
                                type='text'
                                className='form-control'
                                placeholder='Enter contacts company name '
                                value={companyName}
                                onChange={handleCompanyNameChange}
                              />
                            </div>
                            <div className='form-group mb-3'>
                              <label>Anniversary (optional) </label>

                              <ReactDatePicker
                                className='form-control'
                                selected={anniversary}
                                onChange={handleAnniversaryChange}
                                dateFormat='dd/MM'
                                placeholderText='Select Anniversary Day'
                                showYearDropdown={false}
                                scrollableYearDropdown
                              />
                            </div>
                            <div className='form-group mb-3'>
                              <label>Lead Status</label>
                              <select
                                required
                                // disabled
                                className='form-control form-select'
                                value={leadStatus}
                                onChange={handleLeadStatusChange}
                                // disabled={leadStatusList?.length === 0}
                              >
                                <option value={''} selected>
                                  Select Lead Status
                                </option>
                                {leadStatusList?.map((e: any, index: number) => (
                                  <option value={e?.id} key={index}>
                                    {e?.title}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className='col-lg-12 d-flex justify-content-between mt-3'>
                            <button
                              type='button'
                              className='btn btn-light'
                              style={{padding: '10px 30px', borderRadius: 20}}
                              onClick={clearFields}
                            >
                              Cancel
                            </button>
                            <button
                              type='submit'
                              className='btn btn-dark'
                              style={{padding: '10px 30px', borderRadius: 20}}
                              // onClick={handleFormSubmit}
                            >
                              {isEdit ? 'Edit' : 'Add'}
                            </button>
                          </div>
                        </div>
                      </form>
                    ) : (
                      <div className='row align-items-center mb-5'>
                        <div className='col-lg-12 d-flex flex-wrap justify-content-center mb-5'>
                          <div className='form-group d-flex flex-wrap justify-content-center'>
                            <label className='w-100 text-center'>Profile Photo</label>
                            <div className='d-flex flex-wrap'>
                              <input
                                type='file'
                                accept='image/*'
                                style={{display: 'none'}}
                                onChange={handleImageUploadCompany}
                                ref={fileInputRefCompany}
                              />
                              {selectedImageCompany === null ? (
                                <button
                                  className='bg-light px-5 py-4'
                                  style={{border: 'none', borderRadius: '50%'}}
                                  onClick={(e) => {
                                    e.preventDefault()
                                    if (fileInputRefCompany.current) {
                                      fileInputRefCompany.current.click()
                                    }
                                  }}
                                >
                                  <i className='fa fa-plus'></i>
                                </button>
                              ) : (
                                <div className='selected-image-container w-100'>
                                  <img
                                    className='selected-image'
                                    src={
                                      selectedImageCompany
                                        ? URL.createObjectURL(selectedImageCompany)
                                        : ''
                                    }
                                    onError={handleImageError}
                                    alt='Selected'
                                    height={40}
                                  />
                                  <br />
                                  <button
                                    className='remove-image-button m-3'
                                    style={{background: '#f3f3f3', borderRadius: 10, color: 'red'}}
                                    onClick={handleClearImageCompany}
                                  >
                                    x
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                          {/* Display the selected image */}
                        </div>
                        <div className='col-lg-6'>
                          <div className='form-gorup mb-3'>
                            <label>Company Name</label>
                            <input
                              type='text'
                              className='form-control'
                              value={companyName2}
                              onChange={(e) => setCompanyName2(e?.target?.value)}
                              placeholder='Enter Company Name'
                            />
                          </div>
                          <div className='form-gorup mb-3'>
                            <label>Phone Number</label>
                            <input
                              type='text'
                              className='form-control'
                              placeholder='Enter contacts Phone '
                              value={phoneNumberCompany}
                              onChange={(e) => setPhoneNumberCompany(e?.target?.value)}
                            />
                          </div>

                          <div className='form-gorup mb-3'>
                            <label>Lead Owner</label>
                            <select
                              className='form-control form-select'
                              value={leadOwnerCompany}
                              disabled={leadOwnerList?.length === 0}
                              onChange={(e) => setLeadOwnerCompany(e?.target?.value)}
                            >
                              <option selected>Select Lead Owner</option>
                              {leadOwnerList?.map((e: any, index: number) => (
                                <option value={e?.userDetails?.id} key={index}>
                                  {e?.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className='col-lg-6'>
                          <div className='form-gorup mb-3'>
                            <label>Official Email</label>
                            <input
                              type='text'
                              className='form-control'
                              placeholder='Enter contacts email'
                              value={emailCompany}
                              onChange={(e) => setEmailCompany(e?.target?.value)}
                            />
                          </div>
                          <div className='form-gorup mb-3'>
                            <label>Official Address</label>
                            <input
                              type='text'
                              className='form-control'
                              placeholder='Enter Address '
                              value={officialAddressCompany}
                              onChange={(e) => setOfficialAddressCompany(e?.target?.value)}
                            />
                          </div>

                          <div className='form-gorup mb-3'>
                            <label>Lead Status</label>
                            <select
                              // disabled
                              className='form-control'
                              value={leadStatusCompany}
                              onChange={(e) => setLeadStatusCompany(e?.target?.value)}
                              disabled={leadStatusList?.length === 0}
                            >
                              <option selected>Select Lead Status</option>
                              {leadStatusList?.map((e: any, index: number) => (
                                <option value={e?.id} key={index}>
                                  {e?.title}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className='col-lg-12 d-flex justify-content-between mt-3'>
                          <button
                            type='button'
                            onClick={clearFields}
                            className='btn btn-light'
                            style={{padding: '10px 30px', borderRadius: 20}}
                          >
                            Cancel
                          </button>
                          <button
                            type='button'
                            onClick={handleCompanyFormSubmit}
                            className='btn btn-dark'
                            style={{padding: '10px 30px', borderRadius: 20}}
                          >
                            {isEdit ? 'Edit' : 'Add'}
                          </button>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* begin::Body */}
      <div className='card-body py-3'>
        {/* begin::Table container */}
        <div className='table-responsive'>
          {/* begin::Table */}
          <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
            {/* begin::Table head */}
            <thead>
              <tr className='fw-bold text-muted'>
                <th className='w-25px'>
                  {/* <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      value='1'
                      data-kt-check='true'
                      data-kt-check-target='.widget-9-check'
                    />
                  </div> */}
                </th>
                <th className='min-w-150px'>Customer Name</th>
                <th className='min-w-140px'>Email</th>
                <th className='min-w-140px'>Phone Number</th>
                {/* <th className='min-w-140px'>Company</th> */}
                <th className='min-w-140px'>Status</th>
                <th className='min-w-140px'>Owner</th>
                <th className='min-w-140px'>Date Updated</th>
                <th className='min-w-100px text-end'>Actions</th>
              </tr>
            </thead>
            {/* end::Table head */}
            {/* begin::Table body */}
            <tbody>
              {customerList?.map((e: any, index: number) => (
                <tr key={index}>
                  <td>
                    {/* <div className='form-check form-check-sm form-check-custom form-check-solid'>
                      <input
                        className='form-check-input widget-9-check'
                        type='checkbox'
                        value='1'
                      />
                    </div> */}
                  </td>
                  <td>
                    <div className='d-flex align-items-center'>
                      <div className='d-flex justify-content-start flex-column'>
                        <Link
                          to={'/contact/details/' + e?.id}
                          className='text-dark fw-bold text-hover-primary fs-6'
                        >
                          <img
                            src={avatarImgPath + '/' + e?.image}
                            onError={handleImageAvatarError}
                            style={{width: 35, height: 35, borderRadius: '50%', marginRight: 10}}
                          />
                          {e?.name ? e?.name : 'n/a'}
                        </Link>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span className='text-dark fw-bold text-hover-primary fs-6'>
                      {e?.email ? e?.email : 'n/a'}
                    </span>
                  </td>
                  <td>
                    <span className='text-dark fw-bold text-hover-primary fs-6'>
                      {e?.phone ? e?.phone : 'n/a'}
                    </span>
                  </td>
                  {/* <td>
                    <span className='text-dark fw-bold text-hover-primary fs-6 text-capitalize'>
                      {e?.company_name ? e?.company_name : 'n/a'}
                    </span>
                  </td> */}
                  <td>
                    {e?.lead_status_id === 2 ? (
                      <span className='badge badge-light-success'>Customer</span>
                    ) : (
                      <span className='badge badge-light-info'>New Lead</span>
                    )}
                  </td>
                  <td>                    
                    <span className='text-dark fw-bold text-hover-primary fs-6 text-capitalize'>
                      {e?.leadOwnerDetails ? e?.leadOwnerDetails : 'n/a'}
                    </span>
                  </td>
                  <td>
                    <span className='text-dark fw-bold text-hover-primary fs-6'>
                      {e?.updated_at ? moment(e?.updated_at).format('Do MMMM, YYYY') : 'n/a'}
                    </span>
                  </td>

                  <td>
                    <div className='d-flex justify-content-end flex-shrink-0'>
                      <button
                        type='button'
                        onClick={() => handleEdit(e)}
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                      >
                        <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
                      </button>
                      <button
                        onClick={() => handleRemove(e?.id)}
                        type='button'
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                      >
                        <KTSVG
                          path='/media/icons/duotune/general/gen027.svg'
                          className='svg-icon-3'
                        />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
            {/* end::Table body */}
          </table>
          {/* end::Table */}
          {totalPages > 0 && (
            <ReactPaginate
              previousLabel='Previous'
              nextLabel='Next'
              breakLabel='...'
              pageCount={totalPages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={(selected) => handlePageChange(selected.selected)}
              containerClassName='pagination'
              activeClassName='active'
            />
          )}
        </div>
        {/* end::Table container */}
      </div>
      {/* begin::Body */}
    </div>
  )
}

export default CustomerListIndividual
